import React, { memo } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { DateInput, TextInput } from 'framework/form';
import { MinusIcon } from 'framework/ui/mui-builder';
import { FamilyMemberItemProps } from './types';

const FamilyMemberItem = memo(({ member, index, type, isEditMode, removeFamilyMember }: FamilyMemberItemProps) => {
  const isNew = member.isNew === true;
  const namePath = `extendedInformation.${type}.${index}.name`;
  const relationPath = `extendedInformation.${type}.${index}.relation`;
  const dobPath = `extendedInformation.${type}.${index}.dateOfBirth`;

  const fullName = [member.name?.firstName, member.name?.middleName, member.name?.lastName].filter(Boolean).join(' ');
  const dateOfBirth = member.dateOfBirth ? new Date(member.dateOfBirth).toLocaleDateString('ru-RU') : '';

  if (isEditMode && isNew) {
    return (
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Box>
          <Box display="flex" gap={2}>
            <TextInput source={`${namePath}.firstName`} label="First name" />
            <TextInput source={`${namePath}.middleName`} label="Middle name" />
            <TextInput source={`${namePath}.lastName`} label="Last name" />
          </Box>
          <Box display="flex" gap={2}>
            <TextInput source={relationPath} label="Relation" />
          </Box>
          <Box display="flex" gap={2}>
            <DateInput source={dobPath} label="Date of birth" />
          </Box>
        </Box>
        <Button
          aria-label="delete"
          variant="contained"
          sx={{ p: 0, minWidth: 0, width: 20, height: 20 }}
          onClick={() => removeFamilyMember(index, type)}
        >
          <MinusIcon sx={{ fill: 'common.white' }} />
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: isEditMode ? '4.5fr 2.5fr 2fr 1fr' : 'repeat(3, 1fr)',
        },
        gap: 2,
        alignItems: 'center',
        borderBottom: '1px solid lightgrey',
        pb: 1,
        '&:last-child': { borderBottom: 'none' },
      }}
    >
      <Typography variant="body1">{fullName}</Typography>
      <Typography variant="body1">{member.relation}</Typography>
      <Typography variant="body1">{dateOfBirth}</Typography>
      {isEditMode && (
        <Button
          aria-label="delete"
          variant="contained"
          sx={{ p: 0, minWidth: 0, width: 20, height: 20, placeSelf: 'flex-end' }}
          onClick={() => removeFamilyMember(index, type)}
        >
          <MinusIcon sx={{ fill: 'common.white' }} />
        </Button>
      )}
    </Box>
  );
});

export default FamilyMemberItem;
